export default __webpack_public_path__ + "b7170aec121ce8dc593c88ca1c42384d.png";